import { h } from '@stencil/core';
import { SVGOpts } from '../icons-opts';

export const DrillDown = (opts?: SVGOpts) => (
  <svg xmlns="http://www.w3.org/2000/svg" class={opts?.class} viewBox="0 0 6 10">
    <path
      d="M0.55225 9.92218L0.083164 9.47487C0.0299113 9.42402 0 9.3551 0 9.28324C0 9.21137 0.0299113 9.14245 0.083164 9.0916L4.36581 4.99874L0.083164 0.909884C0.0299113 0.859037 0 0.790111 0 0.718249C0 0.646386 0.0299113 0.577465 0.083164 0.526617L0.55225 0.0793019C0.605573 0.0285211 0.677852 0 0.753212 0C0.828573 0 0.900852 0.0285211 0.954175 0.0793019L5.91684 4.81161C5.97009 4.86246 6 4.93138 6 5.00324C6 5.07511 5.97009 5.14403 5.91684 5.19488L0.951026 9.92218C0.897838 9.97205 0.826231 10 0.751638 10C0.677046 10 0.605439 9.97205 0.55225 9.92218Z"
      fill="black"
    />
  </svg>
);
